export default __webpack_public_path__ + "static/media/visitedNode.869ce500.PNG";